<template>
    <div class="main">
        <img src="http://wwj.jijiagames.com/web/act/20190312/result.jpg" alt="" class='result'>
    </div>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {
        };
    },
    methods: {
    },
    mounted() {
    },
    created() {
    }
};
</script>

<style lang="stylus" scoped>
.main
    size 100%
    overflow hidden
    .result
        width 100%
        height 100%
</style>
